import { createOptionsFrom } from "@/lib/common/Option";

export const PriceAlertStepLabels = {
	Step24Hours: "24 Hours",
	Step3Days: "3 Days",
	Step7Days: "7 Days",
	Step14Days: "14 Days",
	Step1Month: "1 Month"
} as const;

export type PriceAlertStep = keyof typeof PriceAlertStepLabels;

export const PriceAlertStepOptions = createOptionsFrom(PriceAlertStepLabels);

export const PriceAlertStepSelectionLabels = {
	None: "No Time Window",
	...PriceAlertStepLabels
} as const;

export type PriceAlertStepSelection = keyof typeof PriceAlertStepSelectionLabels;

export const PriceAlertStepSelectionOptions = createOptionsFrom(PriceAlertStepSelectionLabels);
